import { render, staticRenderFns } from "./BoxPrizeBattle.vue?vue&type=template&id=788844e2&"
import script from "./BoxPrizeBattle.vue?vue&type=script&lang=js&"
export * from "./BoxPrizeBattle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports